import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import { Observable } from "rxjs/Observable";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import * as appConfigActions from "../../../reducers/appconfig.actions";
import { Combo2Service, InvoiceService } from "../../../services/index";
import { PurchaseOrderService } from "../../../services/purchaseorder.service";
import { Subject } from "rxjs/Subject";
import "rxjs/add/operator/debounceTime";
import "rxjs/add/operator/distinctUntilChanged";
import "rxjs/add/operator/switchMap";

@Component({
  selector: "addedit-invoice-tab",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./addEditInvoice.component.html",
})
export class AddEditInvoice implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() _params: any;
  @Output() tabUpdateEvent = new EventEmitter();

  term$ = new Subject<any>();
  mode = "Add";
  canSave: boolean = false;
  hasGrn: boolean = false;
  isChecked: any = false;
  invoice_mode: string = "";
  saveEvent: any;
  rate: any;
  menu: any;
  typelist = ["TRANSPORT", "HAND DELIVERY"];
  designTypeList = ["NEW", "GANG"];
  designFromList = ["ORDERED", "NON-ORDERED"];

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    this.saveEvent = val["data"].tabevent;
    if (this.mode == "Edit" || this.mode == "View") {
      this.hasGrn = this.mode == "Edit" && val["data"].has_grn > 0;
      let invdata = Object.assign({}, val["data"]);
      delete invdata["invdet"];

      this.invdata = invdata;
      this.invdata["invdt"] = new Date(
        ("" + this.invdata["invoice_date"]).replace(
          /(\d{2})-(\d{2})-(\d{4})/,
          "$2/$1/$3"
        )
      );
      this.invdata.date = this.invdata["ref_date"];

      this.invdata.po_no = this.invdata.inv_po_no;

      this.onEnterpono(this.invdata.po_no);
      this.getDesignList(this.invdata["inv_id"]);
      this.getPoNoDesignWise(this.invdata.po_no);
    }

    if (this.mode == "SAMPLE GRN") {
      let invdata = Object.assign({}, val["data"]);
      delete invdata["invdet"];

      this.invdata = invdata;
      this.invdata.date = new Date();

      let grn_id = invdata.grn_id;
      this.invdata.invoice_type = "COURIER";
      this.invdata["po_id"] = invdata.po_id;
      this.invdata["lr_no"] = "";
      this.invdata["po_no"] = invdata.po_no;
      this.invoice_mode = this.mode;
      this.mode = "Add";
      let pono = this.invdata.po_no.split(",");
      this.getSampleGrnDesign(grn_id);
      this.onEnterpono(pono[0]);
    } else {
      this.showbody();
    }
  }

  get params(): any[] {
    return this._params;
  }

  page_id: string = Math.random().toString(36).substr(2, 9) + "_";

  coreList: any;
  shadeIndex: number = 0;
  gangList: any;
  coredesignList: any;
  gangdesignList: any;
  shadeTypeList: any = [];
  shadeType = "";
  isLoading: boolean = false;
  companyList$ = [];
  partyList: any = [];
  finyearList = [];
  designnoList = [];
  nonOrderDesigns = [];
  companyList: Observable<any[]>;
  partycodeList = [];
  ponoDesignList = [];
  ponoDesignList1 = [];
  po_details = [];
  itemList1: Observable<any[]>;

  @ViewChild("partycodeAuto") partycodeAuto;
  @ViewChild("partyAuto") partyAuto;
  @ViewChild("finAuto") gstAuto;
  headerShow: boolean = true;
  bodyShow: boolean = false;
  footerShow: boolean = false;
  invnoControl: FormControl = new FormControl();
  ponoControl: FormControl = new FormControl();
  itemCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  finyearCtrl: FormControl = new FormControl();
  partycomboControl: FormControl = new FormControl();
  invoiceData: any[];
  editShadeOpen: boolean = false;
  showPoDesign: boolean = false;
  invdata = {
    inv_id: "",
    ref_no: "",
    invoice_no: "",
    date: new Date(),
    po_no: "",
    order_no: "",
    invdt: new Date(),
    invoice_type: "TRANSPORT",
    party_name: "",
    party_code: "",
    challan_no: "",
    challan_date: new Date(),
    no_of_bales: "",
    agent: "",
    tax_amount: 0,
    tax_per: 0,
    transport: "",
    discount: 0,
    extras: 0,
    others: 0,
    totalqty: 0,
    totalamt: 0,
    round_off: 0,
    grand_total: 0,
    lrid: "",
    lr_no: "",
    lr_date: new Date(),
    lr_amount: 0,
    weight: "",
    pvt_mark: "",
    party_id: "",
    chr_wt: "",
    act_wt: "",
    location: "",
    courier_name: "",
    courier_no: "",
    courier_date: new Date(),
    inv_po_no: "",
  };
  selected: any = [];
  subcribeTerm: any;
  designList = [
    {
      item_id: 0,
      item_name: "",
      qty: 0,
      uom: "",
      amount: 0,
      width: "",
      design_type: "",
      design_from: "ORDERED",
      nonOrderExists: "NOT EXISTS",
      fabric_design: "",
      design_no: "",
      color: "",
      shade: "",
      dispName: "",
      pcs: "",
      discount: 0,
      distotal: 0,
      gst: 0,
      gstamt: 0,
      rate: 0,
      mrp: 0,
      total: 0,
      mtr: 0,
      po_id: "",
      po_no: "",
      no_of_clrs : 0,
      hsn_code : "",
      isNew: false,
    },
  ];
  designOrderedList = [];
  returnedDesignList = [];

  constructor(
    public store: Store<fromRootStore.State>,
    public toasterService: ToasterService,
    private invService: InvoiceService,
    private combo2Service: Combo2Service,
    private poservice: PurchaseOrderService,
    public datePipe: DatePipe
  ) {
    function hasValidItem(input: FormControl) {
      let id = input.value,
        retVal = null;
      if (id == "") {
        retVal = { inValid: true };
      }
      if (id && typeof id === "string") {
        retVal = { inValid: true };
      }
      return retVal;
    }

    this.partyCtrl = new FormControl("", [
      Validators.required,
      hasValidItem.bind(this),
    ]);
    this.subcribeTerm = this.term$
      .debounceTime(1000)
      .distinctUntilChanged()
      .subscribe((term) => {
        this.onEnterpono(term);
      });
  }
  hotkeys(event) {
    if (this.active) {
    }
  }

  trackByIndex(index: number, value: any) {
    return index;
  }

  ngOnInit(): void {
    if (this.mode == "Edit" || this.mode == "Add") {
      setTimeout(() => {
        this.editShadeOpen = true;
      }, 1000);
    }
    if (this.invoice_mode == "SAMPLE GRN") {
      this.typelist = ["COURIER", "HAND DELIVERY"];
    }
    this.getAuto();
    this.tableScroll();
    this.loadPartyList();
    this.getInvoiceList();
  }

  tableScroll() {
    $(".invscreen").height(window.innerHeight - 470);
    $(".lrbody").width(window.innerWidth - 30);
  }

  ngAfterViewInit() {
    if (this.mode == "Add" || this.mode == "Edit") {
      setTimeout(() => {
        $("#" + this.page_id + "pono1").focus();
      }, 100);
    } else {
      setTimeout(() => {
        $("#" + this.page_id + "date").focus();
      }, 100);
    }
  }

  getAuto() {
    this.invService.getAuto({}).then((res: any) => {
      if (this.mode == "Add") {
        this.invdata.ref_no = res;
      }
    });
  }
  invoicenoExist(invoice_no) {
    let params = {
      invoice_no: invoice_no,
    };
    this.invService.invoicenoExist(params).then((res: any) => {
      if (res.success) {
        let invoice_no = res.data[0].invoice_no;
        swal("invoice No " + invoice_no + " already Exists");
        this.invdata.invoice_no = "";
      }
    });
  }
  getDesignList(id) {
    let params = {
      inv_id: id,
    };
    this.invService.getDesignList(params).then((res: any) => {
      this.designList = res.data;
      this.calcTotal();
    });
  }

  onEnterpono(pono) {
    var regex = /^[A-Za-z0-9 ]+$/;
    var isValid = regex.test(pono);
    if (isValid) {
      if (pono == null) {
        this.invdata["po_id"] = "";
        this.invdata.party_id = "";
        this.invdata.party_code = "";
        this.invdata.party_name = "";
      } else {
        let params = {
          po_no: pono,
        };
        let that = this;
        that.po_details = [];
        that.invService.getDesignno(params).then((res: any) => {
          if (res.data.length > 0) {
            that.designnoList = res.data;
             that.po_details = res.po_details;
            that.invdata.party_id = res.data[0].party_id;
            that.invdata.party_code = res.data[0].party_code;
            // that.invdata.party_name = res.data[0].party_name;
            that.invdata["po_date"] = res.data[0].po_date;
            that.invdata["po_id"] = res.data[0].po_id;
            that.OnclickPartyCode(that.invdata.party_code);
            that.coreGangList();
          } else {
            this.invdata["po_id"] = "";
            this.invdata.party_id = "";
            this.invdata.party_code = "";
            this.invdata.party_name = "";
            this.toasterService.pop({
              bodyOutputType: 1,
              type: "error",
              title: "Please Enter the valid Po.no",
            });
          }
        });
      }
    } else {
      let ponos = pono.split(",");
      let ind = ponos.length;
      let params = {
        // po_no: ponos[ind - 1],
           po_no: ponos,
      };
      let that = this;
      that.po_details = [];
      this.invService.getDesignno(params).then((res: any) => {
        if (res.data.length > 0) {
          that.po_details = res.po_details;
          that.designnoList = that.designnoList.concat(res.data);
          that.nonOrderDesigns = that.nonOrderDesigns.concat(
            res.nonOrderDesigns
          );
          that.invdata.party_id = res.data[0].party_id;
          that.invdata.party_code = res.data[0].party_code;
          that.invdata["po_date"] = res.data[0].po_date;
        }
      });
    }
  }
  poMerge(pono) {
    let ponos = pono.split(",");
    let ind = ponos.length;
    let params = {
      po_no: ponos[ind - 1],
      pono: pono,
    };
    let that = this;
    that.invService.getDesignno(params).then((res: any) => {
      if (res.success == false) {
        that.invdata["po_id"] = "";
        that.invdata.party_id = "";
        that.invdata.party_code = "";
        that.invdata.party_name = "";
        that.invdata.po_no = "";
        that.po_details = [];
        swal(res.message);
      } else {
        if (res.data.length > 0) {
          that.designnoList = that.designnoList.concat(res.data);
          that.nonOrderDesigns = that.nonOrderDesigns.concat(
            res.nonOrderDesigns
          );

          that.invdata["po_id"] =
            that.invdata["po_id"] + "," + res.data[0].po_id;

          that.po_details = res.po_details;

          that.getPoNoDesignWise(that.invdata.po_no);
          that.coreGangList();
        }
      }
    });
  }

  displayParty(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "Party") {
      list = this.partycodeList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { genLedid: id });
      return fitem["party_code"];
    }
    return "";
  }

  loadPartyList() {
    let that = this;
    this.combo2Service.partycodeCombo().then((res: any) => {
      that.partycodeList = res.data;
    });
  }

  OnclickPartyCode(code) {
    let params = {
      code: code,
    };

    let that = this;
    this.invService.partyList(params).then((res: any) => {
      that.partyList = res.data;
      if (that.mode == "Edit") {
        that.partycomboControl.setValue(res.data.name);
      }
    });
  }

  loadfinyearList() {
    let that = this;
    this.combo2Service.finyearCombo().then(function (res) {
      that.finyearList = res.data;
      that.finyearCtrl.setValue(res.data[0].fin_id);
    });
  }

  displayFinyear(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "FinYear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id + "" });
      return fitem["finyear"];
    }
    return "";
  }

  onEnterKeyPressed(nextEl: string): void {
    if (nextEl == "design_from-0") {
      setTimeout(() => {
        $("#" + this.page_id + nextEl).focus();
      }, 500);
    } else {
      $("#" + this.page_id + nextEl).focus();
    }

    let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
    a.removeClass("mat-autocomplete-visible");
  }

  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind,
      design = this.designList[ind]["design_no"],
      shade = this.designList[ind]["shade"],
      qtyval = this.designList[ind]["qty"],
      amount = this.designList[ind]["amt"],
      gst = this.designList[ind]["gst"],
      gstamt = this.designList[ind]["gstamt"],
      qty = this.designList[ind]["qty"],
      hsn_code = this.designList[ind]["hsn_code"],
      rateval = this.designList[ind]["rate"];

    let nxtRow = $("#row-" + ind).next("tr");
    if (fld == "design_from" && nxtRow.length == 0) {
      let len = this.designList.length;
      let design_no = this.designList[len - 1]["design_no"];
      let qty = this.designList[len - 1].qty;
      nxtInd = nxtInd + 1;
      $("#" + this.page_id + fld + "-" + nxtInd).focus();

      if (design_no != "" && nxtInd == len) {
        this.designList.push({
          item_id: 0,
          item_name: "",
          qty: 0,
          uom: "",
          amount: 0,
          width: "",
          design_no: "",
          design_type: "",
          design_from: "",
          nonOrderExists: "NOT EXISTS",
          fabric_design: "",
          color: "",
          pcs: "",
          shade: "",
          dispName: "",
          discount: 0,
          distotal: 0,
          gst: 0,
          gstamt: 0,
          rate: 0,
          mrp: 0,
          total: 0,
          mtr: 0,
          po_id: "",
          po_no: "",
          no_of_clrs : 0,
          hsn_code : "",
          isNew: true,
        });
      
        this.designList[nxtInd].design_from = this.designList[
          nxtInd - 1
        ].design_from;
        setTimeout(() => {
          $("#" + this.page_id + fld + "-" + nxtInd).focus();
        }, 500);
      } else if (design_no == "" && nxtInd == len) {
        let a = nxtInd - 1;
        setTimeout(() => {
          $("#" + this.page_id + fld + "-" + a).focus();
        }, 500);
      } else {
        setTimeout(() => {
          $("#" + this.page_id + fld + "-" + nxtInd).focus();
        }, 500);

        return false;
      }

      //   nxtInd = this.designList.length - 1;
    } else if (fld == "qty") {
      $("#" + this.page_id + fld + "-" + nxtInd).select();
    } else if (fld == "rate") {
      $("#" + this.page_id + fld + "-" + nxtInd).select();
    } else if (fld == "item_name") {
      let nxtRowID = nxtRow[0].id;
      nxtInd = nxtRowID.split("-")[1];
    } else {
      setTimeout(() => {
        $("#" + this.page_id + fld + "-" + nxtInd).focus();
      }, 100);
    }

    if (fld == "amt") {
      this.checkRate(design, shade, rateval, ind);
    }
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    //
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + this.page_id + fld + "-" + ind).length > 0) {
      $("#" + this.page_id + fld + "-" + ind).focus();
    }
  }
  onGoToRightAndLeft($event, fld, arrow, ind) {
    /*        $event.preventDefault();
                if ($('typeahead-container').length > 0) {
                    return false;
                }*/
    if (arrow == "Right") {
    }
    if (arrow == "Left") {
    }

    if ($("#" + this.page_id + fld + "-" + ind).length > 0) {
      $("#" + this.page_id + fld + "-" + ind).focus();
    }
  }
  onkeyrightleft($event, arrow, fld) {
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }

    if ($("#" + this.page_id + fld).length > 0) {
      $("#" + this.page_id + fld).focus();
    }
  }
  onkeydown($event, arrow, ind, fld) {
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }

    if (arrow == "up") {
      ind--;
    } else {
      ind++;
    }
    if (ind < 0) {
      $("#" + this.page_id + "discount").focus();
    } else if (ind < 0) {
      $("#" + this.page_id + "item-0").focus();
    }

    if ($("#" + this.page_id + fld + "-" + ind).length > 0) {
      $("#" + this.page_id + fld + "-" + ind).focus();
    }
  }
  onupanddown($event, fld, arrow) {
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") {
      if (fld == "item") {
        $("#" + this.page_id + "item-0").focus();
      } else {
        $("#" + this.page_id + "discount").focus();
      }
    } else {
      if (fld == "gstamnt") {
        $("#" + this.page_id + "gstamnt").focus();
      } else if (fld == "gstper") {
        $("#" + this.page_id + "gstper").focus();
      } else {
        $("#" + this.page_id + "amnt-0").focus();
      }
    }
  }
  calcAmt($event, ind) {
    let design = this.designList[ind];

    let qty = design.qty;
    let rate = design.rate;
    let amount = 0;
    amount = qty * rate;

    this.designList[ind].amount = parseFloat(amount.toFixed(2));
    this.calcTotal();
  }
  checkRate(design_no, shade, rate, ind) {
    let params = {
      rate: rate,
      design_no: design_no,
      shade: shade,
    };
    let that = this;
    this.invService.checkRate(params).then(function (res: any) {
      if (!res.success) {
        swal(
          "Please enter the correct party rate.<br> Party rate of " +
            design_no +
            "-" +
            shade +
            " is " +
            res.rate +
            "."
        );
        that.designList[ind].item_id = 0;
        that.designList[ind].item_name = "";
        that.designList[ind].qty = 0;
        that.designList[ind].uom = "";
        that.designList[ind].amount = 0;
        that.designList[ind].width = "";
        that.designList[ind].design_no = "";
        that.designList[ind].fabric_design = "";
        
        that.designList[ind].design_type = "ORDERED";
        that.designList[ind].color = "";
        that.designList[ind].shade = "";
        that.designList[ind].pcs = "";
        that.designList[ind].dispName = "";
        that.designList[ind].discount = 0;
        that.designList[ind].gst = 0;
        that.designList[ind].gstamt = 0;
        that.designList[ind].rate = 0;
        that.designList[ind].mrp = 0;
        that.designList[ind].total = 0;
        that.designList[ind].mtr = 0;
        that.designList[ind]["po_rate"] = 0;
        that.designList[ind].hsn_code = "";

        that.calcTotal();
      }
    });
  }
  calcTotal() {
    let designinv = this.designList;
    let totqty = 0,
      totalamt = 0;
    let disamt = 0;
    let roundoff = 0;
    let grantTotal = 0;
    let rnd = 0;
    let tax_per = this.invdata.tax_per;
    let taxamt = 0;
    let discount = this.invdata.discount;
    let tax = this.invdata.tax_per;
    let extras = this.invdata.extras;
    let otheramt = this.invdata.others;
    if (isNaN(discount)) {
      discount = 0;
    }
    if (isNaN(extras)) {
      extras = 0;
    }
    if (isNaN(otheramt)) {
      otheramt = 0;
    }
    if (isNaN(this.invdata.round_off)) {
      this.invdata.round_off = 0;
    }

    for (let i = 0; i < designinv.length; i++) {
      let item = designinv[i];
      if (this.invoice_mode == "SAMPLE GRN") {
        if (item["isChecked"]) {
          totqty += item.qty;
          totalamt += item.amount;
        }
      } else {
        totqty += item.qty;
        totalamt += item.amount;
      }
    }
    taxamt = ((totalamt - discount + extras) * tax_per) / 100;
    if (isNaN(taxamt)) {
      taxamt = 0;
    }

    grantTotal = totalamt - discount + taxamt + extras + otheramt;
    this.invdata.totalqty = parseFloat(totqty.toFixed(2));
    this.invdata.tax_amount = parseFloat(taxamt.toFixed(2));
    this.invdata.totalamt = parseFloat(totalamt.toFixed(2));
    // this.invdata.round_off = parseFloat((roundoff).toFixed(2));
    this.invdata.grand_total = grantTotal + this.invdata.round_off;
    this.invdata.grand_total = parseFloat(this.invdata.grand_total.toFixed(2));
    this.invdata["grandtotal"] = this.moneyFormat(this.invdata.grand_total);
  }

  moneyFormat(nStr) {
    if (nStr == null || nStr == undefined || nStr == "" || nStr == 0)
      return 0.0;
    let no = parseFloat(nStr).toFixed(2);
    /*if (no < 0) {
            nStr = no * -1;
        }
        nStr += '';*/

    let x = no.split(".");
    let x1 = x[0];
    let x2 = x.length > 1 ? "." + x[1] : "";
    let rgx = /(\d+)(\d{3})/;
    let z = 0;
    let len = x1.length;
    let num = len / 2 - 1;
    let newval = Math.floor(num);

    while (rgx.test(x1)) {
      if (z > 0) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      } else {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
        rgx = /(\d+)(\d{2})/;
      }
      z++;
      newval--;
      if (newval == 0) {
        break;
      }
    }

    let out = x1 + x2;
    if (Number(no) < 0) {
      out = "(" + out + ")";
    }
    return out;
  }

  addRow() {
    const last = this.designList[this.designList.length - 1];
    if (!last.design_no || last.design_no.trim() === '') {
      swal({ title: 'Fill design no in the last row first', type: 'warning', confirmButtonText: 'Ok' });
      setTimeout(() => {
        $("#" + this.page_id + "design-" + (this.designList.length - 1)).focus();
      }, 200);
      return;
    }
    const prevDesignFrom = last.design_from || 'ORDERED';
    this.designList.push({
      item_id: 0, item_name: '', qty: 0, uom: '', amount: 0, width: '',
      design_no: '', design_type: '', design_from: prevDesignFrom,
      nonOrderExists: 'NOT EXISTS', fabric_design: '', color: '', pcs: '',
      shade: '', dispName: '', discount: 0, distotal: 0, gst: 0, gstamt: 0,
      rate: 0, mrp: 0, total: 0, mtr: 0, po_id: '', po_no: '',
      no_of_clrs: 0, hsn_code: '', isNew: true,
    });
    setTimeout(() => {
      $("#" + this.page_id + "design_from-" + (this.designList.length - 1)).focus();
    }, 100);
  }

  onDeleteRow($event, fld, ind) {
    $event.preventDefault();
    let that = this;
    swal({
      title: "Are you sure to delete this row?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        if (that.designList.length > 1) {
          that.designList.splice(ind, 1);
          $("#amt" + "-" + (ind - 1)).focus();

          // if ($("#" + this.page_id + fld + "-" + (ind - 1)).length > 0) {
          //   $("#" + this.page_id + fld + "-" + (ind - 1)).focus();
          // } else if ($("#" + this.page_id + fld + "-" + (ind + 1)).length > 0) {
          //   $("#" + this.page_id + fld + "-" + (ind + 1)).focus();
          // }
        }
        that.calcTotal();
      },
      function (dismiss) {}
    );
  }

  onBlurItem($event, item, ind) {}

  filterItems(name: string, comboType: string) {
    let list: any[];
    if (comboType == "Company") {
      list = this.companyList$;
    } else if (comboType == "Party") {
    }
    name = _.escapeRegExp(name);
    return list.filter((item) => new RegExp(name, "gi").test(item.name));
  }

  onSelectItem($event, item, ind) {
    if (!$event || !$event.item) {
      return;
    }

    if(this.mode == "Edit"){
      if(this.designList[ind].design_from == "NON-ORDERED"){
      this.designList[ind].fabric_design = "";
      this.designList[ind].pcs = "";
      this.designList[ind].qty = 0;
      this.designList[ind]["po_rate"] = "";
      this.designList[ind].rate = 0;
      this.designList[ind].amount = 0;
      }

    }

    if (this.invdata.po_no == "") {
      this.toasterService.pop({
        bodyOutputType: 1,
        type: "error",
        title: "Please Enter Po.no",
      });
    } else {


      item.color = $event.item.color;
      item.width = $event.item.width;
      for (let i = 0; i < this.designList.length; i++) {
        if ($event.item.design_no == this.designList[i].design_no) {
          this.designList[ind].shade = this.designList[i].shade;
          this.designList[ind].pcs = this.designList[i].pcs;
          this.designList[ind].qty = this.designList[i].qty;
          this.designList[ind]["po_rate"] = this.designList[i]["po_rate"];
          this.designList[ind].design_type = this.designList[i].design_type;
          this.designList[ind].rate = this.designList[i].rate;
          this.designList[ind].amount = this.designList[i].amount;
          this.designList[ind].hsn_code = this.designList[i].hsn_code;

        }
      }
    }
  }

  getPoRateFabricDesign(desno, item) {
    // let params = {
    //     des_no:desno,
    //     po_no: this.invdata.po_no,
    // }
    // this.invService
    //     .getPoRateFabricDesign(params)
    //     .then((res: any) => {

    //         item.po_rate = res;
    //     });

    this.designnoList.forEach((element) => {
      if (desno == element.design_no) {
        console.log("7777777777777777777777777777777777777777777",this.designnoList,item)
        item.po_rate = element.rate;
        item.rate = element.rate;
        item.fabric_design = element.fabric_design;
        item.design_type = element.design_type
      }
    });
  }

  resetInvoiceForm() {
    this.designList = [
      {
        item_id: 0,
        item_name: "",
        qty: 0,
        uom: "",
        amount: 0,
        width: "",
        design_no: "",
        design_type: "",
        design_from: "ORDERED",
        nonOrderExists: "NOT EXISTS",
        fabric_design: "",
        color: "",
        shade: "",
        pcs: "",
        dispName: "",
        discount: 0,
        distotal: 0,
        gst: 0,
        gstamt: 0,
        rate: 0,
        mrp: 0,
        total: 0,
        mtr: 0,
        po_id: "",
        po_no: "",
        no_of_clrs : 0,
        hsn_code : "",
        isNew: false,
      },
    ];

    this.invdata = {
      inv_id: "",
      ref_no: "",
      invoice_no: "",
      date: new Date(),
      po_no: "",
      order_no: "",
      invdt: new Date(),
      party_name: "",
      party_code: "",
      challan_no: "",
      challan_date: new Date(),
      no_of_bales: "",
      invoice_type: "",
      agent: "",
      tax_amount: 0,
      tax_per: 0,
      transport: "",
      discount: 0,
      extras: 0,
      others: 0,
      totalqty: 0,
      totalamt: 0,
      round_off: 0,
      grand_total: 0,
      lrid: "",
      lr_no: "",
      lr_date: new Date(),
      lr_amount: 0,
      weight: "",
      pvt_mark: "",
      party_id: "",
      chr_wt: "",
      act_wt: "",
      location: "",
      courier_name: "",
      courier_no: "",
      courier_date: new Date(),
      inv_po_no: "",
    };
  }

  oncheckemptyrow() {
    let design = this.designList;
    let desList = [];
    for (let i = 0; i < design.length; i++) {
      if(!design[i].hsn_code) {
        swal("Please enter the hsn code!");
        return false;
      } else {
        if (design[i].design_no != "") {
          desList.push(design[i]);
        }
      }
      
    }
    this.designList = desList;
    this.onSaveInvoice();
  }

  onSaveInvoice(): void {
    if (
      this.invdata.po_no == null ||
      this.invdata.invoice_no == null ||
      this.invdata.agent == "" ||
      this.invdata.lr_no == null
    ) {
      swal("Make sure that all the entries are given!");
    } else {
      let splitpo_id = String(this.invdata["po_id"])
        .split(",")
        .filter(function (item, pos, self) {
          return self.indexOf(item) == pos;
        });
      this.invdata["po_id"] = splitpo_id.toString();
      this.invdata["tabevent"] = undefined;
      let params: any = Object.assign({}, this.invdata);

      params["inv_id"] = this.invdata.inv_id;
      params["challan_no"] = this.invdata.challan_no;
      params["mode"] = this.mode;
      params["invoice_mode"] = this.invoice_mode;
      params["invdt"] = this.datePipe.transform(params["invdt"], "yyyy-MM-dd");
      params["date"] = this.datePipe.transform(params["date"], "yyyy-MM-dd");
      params["challan_date"] = this.datePipe.transform(
        params["challan_date"],
        "yyyy-MM-dd"
      );
      params["lr_date"] =
        this.datePipe.transform(params["lr_date"], "yyyy-MM-dd") || "";
      params["designList"] = JSON.stringify(this.designList);
      params["narration"] = this.invdata["narration"] || "";
      params["transport"] = this.invdata.transport || "";
      params["location"] = this.invdata.location || "";
      params["act_wt"] = this.invdata.act_wt || "";
      params["chr_wt"] = this.invdata.chr_wt || "";
      params["weight"] = this.invdata.weight || "";
      params["lr_amount"] = this.invdata.lr_amount || "";
      params["pvt_mark"] = this.invdata.pvt_mark || "";
      params["courier_name"] = this.invdata.courier_name || "";
      params["courier_no"] = this.invdata.courier_no || "";
      params["courier_date"] =
        this.datePipe.transform(this.invdata.courier_date, "yyyy-MM-dd") || "";
      let that = this;
      swal({
        title: "Are you sure to save this Invoice?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, want to change",
      }).then(
        function () {
          if (that.invoice_mode == "SAMPLE GRN") {
            that.designList = that.designList.filter(
              (el) => el["isChecked"] == true
            );
          }
          that.isLoading = true;
          that.invService
            .addUpdateInvoice(params)
            .then(function (res: any) {
              that.isLoading = false;
              if (that.saveEvent) {
                that.saveEvent.emit();
              }

              if (res.success) {
                that.toasterService.pop({
                  bodyOutputType: 1,
                  type: "success",
                  title: "SUCCESS",
                  body: res.message,
                });
                that.store.dispatch(new appConfigActions.SetLoadInvoice(true));
                if (that.mode == "Add") {
                  that.resetInvoiceForm();
                  that.getAuto();
                  let tabObj = {
                    action: "CloseTab",
                    params: {},
                  };
                  that.tabUpdateEvent.emit(tabObj);
                  if (that.invoice_mode == "SAMPLE GRN") {
                    let tabObj = {
                      action: "CloseTab",
                      params: {},
                    };
                    that.tabUpdateEvent.emit(tabObj);
                  }
                  //    that.loadInvNoItemList();
                } else {
                  let tabObj = {
                    action: "CloseTab",
                    params: {},
                  };
                  that.tabUpdateEvent.emit(tabObj);
                }
              } else {
                swal("ERROR", res.message, "error");
              }
            })
            .catch(function (error: any) {
              that.isLoading = false;
              let res = JSON.parse(error._body);
              swal("ERROR", res.message, "error");
            });
        },
        function (dismiss) {}
      );
    }
  }
  checkInvoiceRepeat() {
    let date = this.datePipe.transform(this.invdata.invdt, "yyyy-MM-dd");
    let exists = this.invoiceData.findIndex(
      (el) =>
        el.party_code == this.invdata.party_code &&
        el.invoice_no == this.invdata.invoice_no &&
        el.invoice_date == date
    );
    if (exists != -1) {
      swal("INVOICE ALREADY EXISTS");
      this.canSave = true;
    } else {
      this.canSave = false;
    }
  }
  getInvoiceList(): void {
    let params = {
      start: 0,
      limit: "",
      orderColumn: `inv.inv_id`,
      orderDir: `ASC`,
      invoice_no: "",
      party: "",
      po_no: "",
      inv_from_date: "",
      inv_to_date: "",
    };
    let that = this;
    this.invService.invoiceList(params).then(function (res: any) {
      that.invoiceData = res.data;
    });
  }
  coreGangList() {
    if (this.invdata.party_id && this.invdata.party_id != "") {
      let params = {
        party_id: this.invdata.party_id,
      };
      this.poservice.coreGangList(params).then((res: any) => {
        this.coreList = res.coreList;
        // this.coredesignList = Array.from(new Set(this.coreList.map((item: any) => item.design_no && item.party_rate)));
        let mymap = new Map();

        this.coredesignList = this.coreList.filter((el) => {
          const val = mymap.get(el.design_no);
          if (val) {
            if (el.design_no < val) {
              mymap.delete(el.design_no);
              mymap.set(el.design_no, el.party_rate);
              return true;
            } else {
              return false;
            }
          }
          mymap.set(el.design_no, el.party_rate);
          return true;
        });

        // this.gangList = res.gangList;

        // let mymap1 = new Map();
        // this.gangdesignList = this.gangList.filter((el) => {
        //   const val = mymap1.get(el.design_no);
        //   if (val) {
        //     if (el.design_no < val) {
        //       mymap1.delete(el.design_no);
        //       mymap1.set(el.design_no, el.party_rate);
        //       return true;
        //     } else {
        //       return false;
        //     }
        //   }
        //   mymap1.set(el.design_no, el.party_rate);
        //   return true;
        // });

        // this.gangdesignList = Array.from(
        //   new Set(
        //     this.coreList.map((item: any) => item.design_no && item.party_rate)
        //   )
        // );
      });
    }
  }
  onClickValidation(design_no, ind, element, arrayList) {
    let partyCodeList = arrayList.filter((el) => el.design_no == design_no);
    if (
      partyCodeList.length <= 0 &&
      this.designList[ind].design_no != "" &&
      this.designList[ind].design_from == "ORDERED"
    ) {
      this.designList[ind].design_no = "";
      $("#" + this.page_id + "element" + "-" + ind).focus();
      swal({
        title: "INVALID DESIGN NO",
        type: "error",
        text: "PLEASE ENTER VALID DESIGN",
        confirmButtonText: "Ok!",
      });
    } else {
      this.designList[ind].rate = partyCodeList[0].party_rate;
      this.designList[ind].color = partyCodeList[0].color;
      this.designList[ind].width = partyCodeList[0].width;
    }
  }

  designnoExistsInPO(design_no, ind) {
    if (design_no != "" && this.designList[ind].design_from == "ORDERED") {
      let exists = this.designnoList.find((el) => el.design_no == design_no);

      if (!exists) {
        this.designList[ind].design_no = "";
        swal("Non-ordered design...Please enter ordered design");
        return;
      }
    }
  }
  async designnoShadeExistsInPO(shade) {
    let canProceed = false;
    if (this.designList[this.shadeIndex].design_from == "NON-ORDERED") {
      let nonOrderExists = this.nonOrderDesigns.find(
        (el) =>
          el.party_design.toLowerCase() ==
            this.designList[this.shadeIndex].design_no.toLowerCase() &&
          shade == el.party_shade
      );
      if (nonOrderExists) {
        this.designList[this.shadeIndex].nonOrderExists = "EXISTS";
        swal("This design already exists in Sample GRN non-order");
      } else {
        if (this.designList[this.shadeIndex].nonOrderExists != "EXISTS") {
          this.designList[this.shadeIndex].nonOrderExists = "NOT EXISTS";
        }
      }
      canProceed = true;
      return canProceed;
    }
    await this.onEnterpono(this.invdata.po_no);

    let designExists = this.designnoList.filter(
      (el) => el.design_no == this.designList[this.shadeIndex].design_no
    );
    if (designExists && designExists.length > 0) {
      let shadeExists: any;

      for (let el of designExists) {
        shadeExists = String(el.shade)
          .split(",")
          .find((ex) => ex == shade);
        if (shadeExists) {
          canProceed = true;
          break;
        }
      }
      if (!shadeExists) {
        let nonOrderExists = this.nonOrderDesigns.find(
          (el) =>
            el.party_design == this.designList[this.shadeIndex].design_no &&
            shade == el.party_shade
        );
        if (nonOrderExists) {
          this.designList[this.shadeIndex].nonOrderExists = "EXISTS";
          swal("This design already exists in Sample GRN non-order");
        } else {
          if (this.designList[this.shadeIndex].nonOrderExists != "EXISTS") {
            this.designList[this.shadeIndex].nonOrderExists = "NOT EXISTS";
          }
        }

        canProceed = false;
        swal("Non-ordered shade for this design");
      }
    }

    return canProceed;
  }
  // addShade(shade) {
  //   this.designnoShadeExistsInPO(shade).then((response) => {
  //     if (response) {
  //       let exists = this.shadeTypeList.findIndex((el) => el == shade);
  //       if (exists != -1) {
  //         swal("Shade already exists");
  //       } else if (shade != "" && shade) {
  //         if (this.designList[this.shadeIndex].design_type == "CORE") {
  //           let des_no = this.designList[this.shadeIndex].design_no;
  //           let coreExists = this.coreList.findIndex(
  //             (el) => el.design_no == des_no && el.shade == shade
  //           );
  //           if (coreExists != -1) {
  //             this.shadeTypeList.push(shade);
  //           } else {
  //             swal({
  //               title: "INVALID SHADE FOR THIS CORE DESIGN",
  //               type: "error",
  //               text: "PLEASE ENTER VALID SHADE",
  //               confirmButtonText: "Ok!",
  //             });
  //           }
  //         } else if (this.designList[this.shadeIndex].design_type == "GANG") {
  //           let des_no = this.designList[this.shadeIndex].design_no;
  //           let gangExists = this.gangList.findIndex(
  //             (el) => el.design_no == des_no && el.shade == shade
  //           );
  //           if (gangExists != -1) {
  //             this.shadeTypeList.push(shade);
  //           } else {
  //             swal({
  //               title: "INVALID SHADE FOR THIS GANG DESIGN",
  //               type: "error",
  //               text: "PLEASE ENTER VALID SHADE",
  //               confirmButtonText: "Ok!",
  //             });
  //           }
  //         } else {
  //           this.shadeTypeList.push(shade);
  //         }
  //         this.shadeType = "";
  //       }
  //     }
  //   });
  // }

  onClickShade() {
    let ind = this.shadeIndex;
    this.shadeTypeList = this.shadeTypeList.filter((el) => el != "");
    let no_of_clrs = this.shadeTypeList.length > 0 ? this.shadeTypeList.length : 0; 
    this.designList[this.shadeIndex].shade = this.shadeTypeList.toString();
    this.designList[this.shadeIndex].no_of_clrs = no_of_clrs;

    this.setPoNoForDesign(
      this.designList[ind].design_no,
      this.designList[ind].shade,
      ind
    );

    setTimeout(() => {
      $("#" + this.page_id + "po_no" + "-" + this.shadeIndex).focus();
      this.shadeIndex = 0;
    }, 500);
  }

  setPoNoForDesign(design_no, shade, ind) {
    let exists = this.designnoList.filter((el) => el.design_no == design_no);

    if (exists && exists.length > 0) {
      let existspo_id = this.po_details.filter(
        (el) => el.po_id == exists[0].po_id
      );

      if (existspo_id && existspo_id.length > 0) {
        this.ponoDesignList = [];

        this.designList[ind].po_no = existspo_id[0].po_no;
        this.setPoIdDesign(this.designList[ind].po_no, ind);
      }
    } else {
      this.ponoDesignList = this.ponoDesignList1;
    }
  }
  getPoNoDesignWise(po_no) {
    po_no = String(po_no);
    let pono = po_no.split(",");
    this.ponoDesignList = [];
    if (pono.length > 1) {
      this.showPoDesign = true;
      this.ponoDesignList = pono;
      this.ponoDesignList1 = pono;
    } else {
      this.showPoDesign = false;
      this.ponoDesignList = pono;
      this.ponoDesignList1 = pono;
    }

    //filter po design list
    let filteredDesignNoList = [];
    this.po_details.forEach((el) => {
      let duplicateArray = [...this.designnoList];
      let filteredList = duplicateArray.filter((el1) => el.po_id == el1.po_id);
      filteredDesignNoList = filteredDesignNoList.concat(filteredList);
    });

    this.designnoList = filteredDesignNoList;
  }
  setPoIdDesign(po_no, ind) {
    po_no = po_no.trim();
    let exists = this.po_details.filter((el) => el.po_no == po_no);

    if (exists && exists.length > 0) {
      this.designList[ind].po_id = exists[0].po_id;
    } else {
      swal("Please enter valid PO");
    }
  }
  // clearShade(ind) {
  //   this.shadeTypeList.splice(ind, 1);
  // }
  // openModalShade(index, design) {
  //   this.shadeIndex = index;
  //   this.shadeIndex = index;
  //   if (design.design_no != "" && this.editShadeOpen) {
  //     if (this.designList[index].shade != "") {
  //       this.shadeTypeList = this.shadeTypeList.filter((el) => el != "");
  //       this.shadeTypeList = String(this.designList[index].shade).split(",");
  //     } else {
  //       this.shadeTypeList = [];
  //     }
  //     $("#modalInvoice").modal("show");
  //     setTimeout(() => {
  //       $("#shadeType").focus();
  //     }, 500);
  //   }
  // }

  // alphaNumRegex(shade) {
  //   var regex = /^[a-zA-Z0-9]*$/;
  //   if (regex.test(shade)) {
  //     this.addShade(shade);
  //     return true;
  //   } else {
  //     this.shadeType = "";
  //     $("#shadeType").focus();
  //   }
  // }
  getSampleGrnDesign(grn_id) {
    let params = {
      grn_id: grn_id,
    };
    this.invService.getSampleGrnDesignList(params).then((res: any) => {
      this.designList = res.data;
      this.designOrderedList = res.data;
      this.returnedDesignList = res.returned;
      this.calcTotal();
    });
  }
  showHeader() {
    this.bodyShow = false;
    this.footerShow = false;
    this.headerShow = true;
  }
  showbody() {
    if (this.invoice_mode == "SAMPLE GRN") {
      this.designList = this.designList.filter((el) => el.design_no != "");
    }

    this.bodyShow = true;
    this.footerShow = true;
    this.headerShow = false;
  }
  async resetDesignList() {
    this.designList = [
      {
        item_id: 0,
        item_name: "",
        qty: 0,
        uom: "",
        amount: 0,
        width: "",
        design_no: "",
        design_type: "",
        design_from: "ORDERED",
        nonOrderExists: "NOT EXISTS",
        fabric_design: "",
        color: "",
        shade: "",
        pcs: "",
        dispName: "",
        discount: 0,
        distotal: 0,
        gst: 0,
        gstamt: 0,
        rate: 0,
        mrp: 0,
        total: 0,
        mtr: 0,
        po_id: "",
        po_no: "",
        no_of_clrs : 0,
        hsn_code : "",
        isNew: false,
      },
    ];

    return true;
  }
  onChange($event: Event, selected) {
    let el = $event;
    let checked = el["checked"];
    let grn_det_id = selected.grn_det_id;

    if (!checked) {
      this.selected = this.selected.filter((el) => el.grn_det_id != grn_det_id);
    } else {
      this.selected.push(selected);
    }
    this.resetDesignList().then((res) => {
      this.designList = this.designOrderedList.concat(this.selected);
      this.designList = this.designList.filter((el) => el.design_no != "");
      this.calcTotal();
    });
  }
  onChangeSampleDesigns(isChecked) {
    console.log(isChecked);
    this.calcTotal();
  }
  ngOnDestroy() {
    this.subcribeTerm.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/invoice/addEditInvoice.component.ts